// extracted by mini-css-extract-plugin
export default {"Content":"Content_Content__A1TJw","Title":"Content_Title__2UcMv","SubTitle":"Content_SubTitle__p5TVW","BottomContent":"Content_BottomContent__89CG8"};